/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_PolicyInputs */

const en_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const ar_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Privacy Policy`)
};

const de_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datenschutzbestimmungen`)
};

const es_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de privacidad`)
};

const fr_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de confidentialité`)
};

const it_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politica sulla Privacy`)
};

const ja_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライバシーポリシー`)
};

const ko_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개인정보처리방침`)
};

const pt_br_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de Privacidade`)
};

const ru_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Политика конфиденциальности`)
};

const th_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นโยบายความเป็นส่วนตัว`)
};

const tr_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gizlilik Politikası`)
};

const zh_cn_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隐私权政策`)
};

const zh_tw_privacy_policy = /** @type {(inputs: Privacy_PolicyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`隱私權政策`)
};

/**
* | output |
* | --- |
* | "Privacy Policy" |
*
* @param {Privacy_PolicyInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const privacy_policy = /** @type {((inputs?: Privacy_PolicyInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_PolicyInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_policy(inputs)
	if (locale === "ar") return ar_privacy_policy(inputs)
	if (locale === "de") return de_privacy_policy(inputs)
	if (locale === "es") return es_privacy_policy(inputs)
	if (locale === "fr") return fr_privacy_policy(inputs)
	if (locale === "it") return it_privacy_policy(inputs)
	if (locale === "ja") return ja_privacy_policy(inputs)
	if (locale === "ko") return ko_privacy_policy(inputs)
	if (locale === "pt_br") return pt_br_privacy_policy(inputs)
	if (locale === "ru") return ru_privacy_policy(inputs)
	if (locale === "th") return th_privacy_policy(inputs)
	if (locale === "tr") return tr_privacy_policy(inputs)
	if (locale === "zh_cn") return zh_cn_privacy_policy(inputs)
	return zh_tw_privacy_policy(inputs)
});